export const WYCompletedApplicationsTeamsite = {
  heading: 'SUBMITTED APPLICATIONS',
  noResultsMessage: 'There are no completed applications to display',
  sidebar: {
    header: 'SUBMITTED APPLICATIONS',
    subText: 'Review information about customer application status.'
  },
  appSubmitSuccessMessage:
    'The application has been successfully submitted.<br>Please be sure to print a summary for your records.<br>You can choose to make a payment now or wait for a bill to arrive. If you select "Send Me a Bill", coverage will not begin until payment is received for the full amount of the first month\'s premium. If payment is not received by the requested due date, this plan may be cancelled.',
  noPaymentSubmitMessage:
    'The application has been successfully submitted.<br>Please be sure to print a summary for your records.<br>You can choose to make a payment now or wait for a bill to arrive. If you select "Send Me a Bill", coverage will not begin until payment is received for the full amount of the first month\'s premium. If payment is not received by the requested due date, this plan may be cancelled.',
  submitWithPaymentMessage:
    'The application has been successfully submitted.<br>Please be sure to print a summary for your records.<br>Your customer can expect member materials, including their member ID card, to arrive in the mail soon.<br><br>',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made or to determine payment options, email Sales.Support@bcbswy.com.'
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH HIGHMARK'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
export const NDCompletedApplicationsTeamsite = {
  heading: 'SUBMITTED APPLICATIONS',
  noResultsMessage: 'There are no completed applications to display',
  sidebar: {
    header: 'SUBMITTED APPLICATIONS',
    subText:
      'Review information about customer application status from the Health Insurance Marketplace.'
  },
  appSubmitSuccessMessage:
    'The application has been successfully submitted.<br>Please be sure to print a summary for your records.<br>You can choose to make a payment now or wait for a bill to arrive. If you select "Send Me a Bill", coverage will not begin until payment is received for the full amount of the first month\'s premium. If payment is not received by the requested due date, this plan may be cancelled.',
  noPaymentSubmitMessage:
    'No payment was submitted with this online application.<br>Information displayed here does not reflect any payment made outside of this online application.<br>Click <strong>More Info</strong> to see more information and options.',
  submitWithPaymentMessage:
    'BCBSND offers a comprehensive provider directory that your customer can review while waiting for member materials to arrive in the mail. <br>The find a doctor feature of our website allows members to search for health care providers in their network.<br><br>',
  paymentStatusModal: {
    header: 'More Info',
    body:
      'To see if payment has been made and to determine what payment options are available for this plan if payment was not made, contact the Producer Hotline at  1-866-60 -1248  (TTY/TDD: 711) Monday thru Friday 8:00 a.m. – 5:00 p.m. EST'
  },
  buttons: {
    editInfo: {
      display: true,
      text: 'EDIT INFO'
    },
    viewPlans: {
      display: true,
      text: 'VIEW PLANS'
    },
    planDetails: {
      display: true,
      text: 'PLAN DETAILS'
    },
    compare: {
      display: true,
      text: 'COMPARE'
    },
    edit: {
      display: true,
      text: 'EDIT'
    },
    shopPlans: {
      display: true,
      text: 'SHOP DIRECTLY WITH BCBSND'
    },
    goBackToFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    viewResults: {
      display: true,
      text: 'VIEW RESULTS'
    },
    editOnFFM: {
      display: true,
      text: 'GO TO THE MARKETPLACE'
    },
    initialPayment: {
      display: true,
      text: 'MAKE PAYMENT'
    },
    summary: {
      display: true,
      text: 'RETRIEVE'
    },
    moreInfo: {
      display: true,
      text: 'MORE INFO'
    }
  }
};
